import { cartGet, cartAdd, cartGetCurrent, cartUpdate, cartChange } from '@process-creative/slate-theme-tools';

import { bindAssignedElements } from './utils';

export const CLASS_OPEN = 'is-bundle-builder-open';

const template = document.createElement('template');
template.innerHTML = `
  <style>
    :host {
      display: block;
    }

    :root {
      
    }

    .o-customiser__model-viewer {
      margin-top: 1.125rem;
      margin-bottom: 0;
    }

    .o-customiser__model-viewer-info {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #7C8D80;
    }

    .o-customiser__model-viewer-info-text {
      font-size: .875rem;
      font-weight: 400;
      line-height: 1.25rem;
      margin-left: .625rem;
      margin-right: .625rem;
    }

    .o-customiser__model-viewer-toggle {
      display: flex;
      align-items: center;
      border-radius: 24px;
      border: none;
      background: #D1E6C7;
      color: #163021;
      padding: 12px 24px 12px 11px;
      margin: 22px auto -20px;
    }

    .o-customiser__model-viewer-toggle-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 11px;
      padding-bottom: 1px;
      width: 18px;
      height: 18px;
    }

    .o-customiser__model-viewer-toggle-text {
      display: flex;
      align-items: center;
      font-size: 13px;
      line-height: 20px;
      font-weight: 400;
    }

    @media only screen and (max-width: 1099px) {
      :host {
        position: sticky;
        top: 0;
        z-index: 2;
        background: #fcfcfb;
        padding: 2rem;
        padding-bottom: .125rem;
        border-radius: 0 0 2rem 2rem;
        transition: transform 1.4s cubic-bezier(.16,1,.3,1);
      }

      :host(.summary-in-view) {
        
      }

      cylindo-viewer {
        height: 38vh;
      }

      .o-customiser__model-viewer-wrapper {
        transition: height 300ms;
        overflow: hidden;
        height: 38vh;
      }

      .is-show {
        display: none;
      }

      :host(.is-minimised) .is-hide {
        display: none;
      }

      :host(.is-minimised) .is-show {
        display: block;
      }

      :host(.is-minimised) .o-customiser__model-viewer-wrapper {
        height: 8px;
      }

      :host(.is-minimised) .o-customiser__model-viewer-info {
        display: none;
      }
    }

    @media only screen and (min-width: 1100px) {

      :host {
        border-radius: 28px;
        background: #FCFCFB;
        position: fixed;
        top: 2.5rem;
        width: 27.75rem;
        right: 2.5rem;
        bottom: 2.5rem;
        transition: all 500ms;
        padding: .875rem;
      }

      :host(.summary-in-view) {
        //transform: translateY(-50%);
      }

      .o-customiser__model-viewer-toggle {
        display: none;
      }

      .o-customiser__model-viewer {
        text-align: center;
        margin: auto;
      }

      .o-customiser__model-viewer-info-text {
        font-size: 1rem;
        line-height: 1.5rem;
      }

      cylindo-viewer {
        height: calc(100vh - 20rem);
        width: 100%;
        margin: auto;
        transition: height 500ms;
        margin-bottom: 1rem;
      }

      :host(.summary-in-view) cylindo-viewer {
        height: calc(100vh - 10rem);
      }
    }

    @media only screen and (min-width: 1750px) {
      :host {
        top: 3rem;
        right: 3rem;
        bottom: 3rem;
        width: 38.5rem;
      }

      cylindo-viewer {
        height: calc(100vh - 22rem);
      }

      :host(.summary-in-view) cylindo-viewer {
        height: calc(100vh - 14rem);
      }
    }

    @media only screen and (min-width: 2000px) {

      cylindo-viewer {
        height: calc(100vh - 26rem);
      }

      :host(.summary-in-view) cylindo-viewer {
        height: calc(100vh - 14rem);
      }
    }
  </style>

  <div class="o-customiser__model-viewer" part="root">
    <div class="o-customiser__model-viewer-wrapper">
      <cylindo-viewer customer-id="5128">
        <div slot="fallback">
          <h2>Dang!</h2>
          <p class="o-type--1">Something's gone wrong with this product's visualiser. We'll look into it right away.
          <br>Meanwhile, you can still safely customise and add it to your order.</p>
        </div>
      </cylindo-viewer>
    </div>
    <div class="o-customiser__model-viewer-info">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.75 11.375 4.375 7 8.75 2.625"/>
      </svg>
      <span class="o-customiser__model-viewer-info-text">Drag to rotate</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M5.25 2.625 9.625 7 5.25 11.375"/>
      </svg>
    </div>
    <button class="o-customiser__model-viewer-toggle" data-model-viewer-toggle>
      <span class="o-customiser__model-viewer-toggle-icon">
        <svg class="is-show" xmlns="http://www.w3.org/2000/svg" width="19" height="17" fill="none">
          <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
            <path d="m3.875 2.656 11.25 11.688M11.392 10.466a2.913 2.913 0 0 1-2.026.688 2.883 2.883 0 0 1-1.947-.867 2.57 2.57 0 0 1-.729-1.913 2.6 2.6 0 0 1 .918-1.84M10.03 5.89a2.859 2.859 0 0 1 1.552.823c.41.425.661.965.719 1.537"/>
            <path d="M15.168 11.23C16.7 9.932 17.375 8.5 17.375 8.5S15.125 3.719 9.5 3.719c-.487 0-.973.036-1.454.111M5.703 4.555C2.836 5.926 1.625 8.5 1.625 8.5s2.25 4.781 7.875 4.781a8.704 8.704 0 0 0 3.797-.837"/>
          </g>
        </svg>
        <svg class="is-hide" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
          <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10 4.375C3.75 4.375 1.25 10 1.25 10s2.5 5.625 8.75 5.625S18.75 10 18.75 10 16.25 4.375 10 4.375Z"/>
            <path d="M10 13.125a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"/>
          </g>
        </svg>
      </span>
      <span class="o-customiser__model-viewer-toggle-text">
        <span class="is-hide">Hide model</span>
        <span class="is-show">Show model</span>
      </span>
    </button>
  </div>
`;

const modelParams = {
  ROLLERBLIND: {
    single: {
      format: 'ProductTypeModel_Material_Fitting_RollType',
      generateModelId: props => [props.ProductTypeModelId, props.Material, props.Fitting, props.RollDirection],
      fabricFieldIds: ['FABRIC'],
      featureParams: ['BOTTOM', 'BRACKET', 'CHAIN', 'RAIL', 'FABRIC']
    },
    double: {
      format: 'DOUBLEProductTypeModel_Fitting',
      fabricFieldIds: ['FABRICS REAR', 'FABRICS FRONT'],
      generateModelId: props => [`DOUBLE${props.ProductTypeModelId}`, props.Fitting],
      // need to get the client to change these from fabrics front to fabrics FRONT etc.
      featureParams: ['BRACKET', 'CHAIN', 'FABRICS REAR', 'FABRICS FRONT', 'RAIL']
    }
  },
  CURTAIN: {
    single: {
      format: 'ProductTypeModel_Material_Pleating_Fitting_HemType',
      fabricFieldIds: ['FABRIC'],
      generateModelId: props => [props.ProductTypeModelId, props.Material, props.Pleating, props.Fitting, props.HemType],
      featureParams: ['TRACK', 'FABRIC']
    },
    double: {
      format: 'DOUBLEProductTypeModel_SHEER_SheerPleating_BLOCKOUT_BlockoutPleating_Fitting_SheerHemType_BlockoutHemType',
      fabricFieldIds: ['FABRICS SHEER', 'FABRICS BLOCKOUT'],
      generateModelId: props => [`DOUBLE${props.ProductTypeModelId}`, 'SHEER', props.SHEERPleating, 'BLOCKOUT', props.BLOCKOUTPleating, props.Fitting, props.SHEERHemType, props.BLOCKOUTHemType],
      featureParams: ['FABRICS BLOCKOUT', 'FABRICS SHEER', 'TRACK']
    }
  },
  CELLULARBLIND: {
    single: {
      format: 'ProductModelType_Material_Fitting_Cord',
      generateModelId: props => [props.ProductTypeModelId, props.Material, props.Fitting, props.Cord],
      fabricFieldIds: ['FABRIC'],
      featureParams: ['FABRIC']
    }
  },
  ROMANBLIND: {
    single: {
      format: 'ProductModelType_Material',
      generateModelId: props => [props.ProductTypeModelId, props.Material],
      fabricFieldIds: ['FABRIC'],
      featureParams: ['OPERATION', 'FABRIC']
    }
  },
  VENETIANBLIND: {
    single: {
      format: 'ProductModelType_SlatWidth_Fitting_Cord',
      generateModelId: props => [props.ProductTypeModelId, props.SlatWidth, props.Fitting, props.Cord],
      fabricFieldIds: ['FABRIC'],
      featureParams: ['FABRIC']
    }
  },
  VERTICALBLIND_89MM: {
    single: {
      format: 'ProductModelType_Fitting',
      fabricFieldIds: ['FABRIC'],
      generateModelId: props => [props.ProductTypeModelId, props.Fitting],
      featureParams: ['TRACK', 'FABRIC'],
    }
  },
  ALUMINIUMBLIND: {
    single: {
      format: 'ProductModelType',
      fabricFieldIds: ['FABRIC'],
      generateModelId: props => [props.ProductTypeModelId],
      featureParams: ['FABRIC']
    }
  },
  SHUTTER: {
    single: {
      format: 'ProductModelType_ShutterMaterial_Fitting_Frame_ShutterMidrail',
      fabricFieldIds: ['FABRIC'],
      generateModelId: props => [props.ProductTypeModelId, props.ShutterMaterial, props.Fitting, props.Frame, props.ShutterMidrail],
      featureParams: ['FABRIC']
    }
  }
}

export class CustomiserModelViewer extends HTMLElement {
  private cylindoViewer;
  private toggleButton;
  private isOpen;

  constructor() {
    super();

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.cylindoViewer = shadowRoot.querySelector('cylindo-viewer');
    this.toggleButton = shadowRoot.querySelector('[data-model-viewer-toggle]');

    // Bind the event listener for the toggle button
    this.toggleButton?.addEventListener('click', () => {
      this.toggleModelViewer();
    });
  }

  // Function to toggle the CLASS_OPEN class on the root element (:host)
  private toggleModelViewer() {
    this.isOpen = !this.isOpen;
    this.classList.toggle('is-minimised', this.isOpen);
  }

  public getFabricFieldIdsForProductType(productTypeModelId:string, doubleConfig:boolean=false) {
    return this.getConfigForProductType(productTypeModelId, doubleConfig)?.fabricFieldIds || [];
  }

  private getConfigForProductType(productTypeModelId:string, doubleConfig:boolean=false) {
    const singleOrDouble = doubleConfig ? 'double' : 'single';
    return modelParams[productTypeModelId][singleOrDouble]
  }

  private getModelFeatures(props, featureParams) {
    return featureParams.reduce((acc, param) => {
      return {
        ...acc,
        [param]: props[param]
      }
    }, {})
  }

  public updateModel(props) {
    const { ProductTypeModelId, isDoubleConfig } = props;
    const productIsShutter = ProductTypeModelId === 'SHUTTER';
    const singleOrDouble = isDoubleConfig ? 'double' : 'single';
    const { generateModelId, featureParams, format } = modelParams[ProductTypeModelId][singleOrDouble];
    const modelIdValues = generateModelId(props);

    // All products need to have all params filled for their model IDs
    // Shutters have one case where all params don't need to be filled
    if (!productIsShutter && modelIdValues.some(val => !val)) {
      console.warn('Incomplete Model ID', modelIdValues);
      return;
    }
    const formattedModelId = modelIdValues.filter(param => !!param).join('_');
    
    const modelIdDebugging = generateModelId(props).map(idParam => idParam ?? 'undefined').join('_');

    // add to to compare if the id is different
    this.cylindoViewer.code = formattedModelId;
    this.cylindoViewer.setAttribute('code', formattedModelId)


    const features = this.getModelFeatures(props, featureParams);
    this.cylindoViewer.features = features;
  }

}

if(!customElements.get('customiser-model-viewer')) {
  customElements.define('customiser-model-viewer', CustomiserModelViewer);
}